import { HomeView } from './HomeView'
import { SettingsView } from './SettingsView'
import { LoginView } from './LoginView'
import { OktaView } from './OktaView'
import { LogoutView } from './LogoutView'
import { EmbeddedView } from './EmbeddedView'

export { HomeView, SettingsView, LoginView, OktaView, LogoutView, EmbeddedView } 
